/* eslint-disable */
import React from "react";
import { Commodities } from '../../../controls/Commodities';
import { useDictionary, useParameter } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { Skeleton } from "@material-ui/lab";
import { SLIDE_NUMBER } from "../constants";
import { orderBy } from "lodash";
import { HierarchyControl, HierarchyControlItem } from '../../../../basf-ui';

interface ControlItem extends HierarchyControlItem<number> {
    olapCommodity: number;
}

const BUSINESS_UNIT = 1;

export const CommoditiesControl: React.FC = () => {
    const [controlItems, setControlItems] = React.useState<ControlItem[]>([]);
    const [defaultCommodityValue, setDefaultCommodityValue] = React.useState<number | undefined>();

    const [commodityDisplay, setCommodityDisplay] = useParameter<number | null>("@commodities_display");
    const [commodityValue, setCommodityValue] = useParameter<number | null>("@commodities");

    React.useEffect(function initDefaultValue() {
        if (defaultCommodityValue === undefined && commodityValue !== null) {
            setDefaultCommodityValue(commodityValue);
        }
    }, [defaultCommodityValue, commodityValue]);

    const [dictItems, , loading] = useDictionary(dictionaryService, "slides-commodities-display", undefined, {
        business_unit: BUSINESS_UNIT,
        slide: SLIDE_NUMBER,
    });

    React.useEffect(function updateControlItems() {
        if (dictItems) {
            const sortedDictItems = orderBy(dictItems, item => item.getValue<number>("order"));
            const nextControlItems = sortedDictItems.map<ControlItem>(dictItem => ({
                id: Number(dictItem.id),
                name: (dictItem.getValue("name") as any)[9] as string,
                parent: dictItem.getValue<number>("parent"),
                olapCommodity: Number(dictItem.getValue<number>("olap_commodity")),
                disabled: dictItems.some(x => x.getValue<number>('parent')?.toString() === dictItem.id),
            }));
            setControlItems(nextControlItems);

            let selectedItem = nextControlItems.find(item => item.olapCommodity === commodityValue);
            if (selectedItem === undefined) {
                const defaultItem = nextControlItems.find(item => item.olapCommodity === defaultCommodityValue);
                const firstItem = nextControlItems[0];
                selectedItem = defaultItem || firstItem;
            }

            if (commodityDisplay !== selectedItem.id) {
                setCommodityDisplay(selectedItem.id);
            }
            if (commodityValue !== selectedItem.olapCommodity) {
                setCommodityValue(selectedItem.olapCommodity);
            }
        }
    }, [dictItems]);

    const handlerChange = React.useCallback((selectedId: number | undefined | null) => {
        const selectedItem = controlItems.find(item => item.id === selectedId);
        if (selectedItem) {
            setCommodityDisplay(selectedItem.id);
            setCommodityValue(selectedItem.olapCommodity);
        }
    }, [controlItems, commodityValue, commodityDisplay]);

    return <HierarchyControl
        loading={loading}
        label="Commodities"
        value={commodityDisplay}
        onChange={handlerChange}
        items={controlItems}
    />
};
